import { axiosInstance, requestConfig } from 'network/apis';

import { URL_HUB } from 'utils/constants';

export const callShopClientLimitSetting = async (shopGuid, clientGuid) => {
    return await axiosInstance(requestConfig('get', URL_HUB, `/shop/${shopGuid}/clients/${clientGuid}/status`));
};

export const callGameRoundSetting = async (gameRoundId) => {
    return await axiosInstance(requestConfig('get', URL_HUB, `/api/clientstatus/gameroundsetting/${gameRoundId}`));
};
